exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color[data-v-93c4bde6] {\n  height: 22px;\n  border-radius: 4px;\n  width: 50px;\n}\n.color.green[data-v-93c4bde6] {\n  background: #7EEECE;\n}\n.color.yellow[data-v-93c4bde6] {\n  background: #fbecbe;\n}\n.color.red[data-v-93c4bde6] {\n  background: #f9a0a0;\n}\n.color.black[data-v-93c4bde6] {\n  background: #ccd5dd;\n}", ""]);

// exports
